/**
 * Normalize a human-typed tag string to the canonical SCREAMING_SNAKE_CASE
 * form the backend expects (e.g. "Patient Note" → "PATIENT_NOTE"). Mirrors the
 * backend canonicalization so the FE can detect collisions with reserved flag
 * classes before issuing a PATCH.
 *
 * Returns `null` when the input is empty after trimming.
 */
export function normalizeTagInput(raw: string): string | null {
  const trimmed = raw.trim();
  if (trimmed === '') return null;

  const collapsed = trimmed
    .toUpperCase()
    .replace(/[^A-Z0-9]+/g, '_')
    .replace(/^_+|_+$/g, '');

  return collapsed === '' ? null : collapsed;
}
